"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = exports.ConfigurationProvider = void 0;
var _react = require("react");
const configurationContext = /*#__PURE__*/(0, _react.createContext)({});
const ConfigurationProvider = exports.ConfigurationProvider = configurationContext.Provider;
const useConfiguration = () => (0, _react.useContext)(configurationContext);
exports.useConfiguration = useConfiguration;
